import { COLORS, TYPOGRAPHY } from '../../constants/theme';

const TimelineLink = ({ href, onClick, children, style = {} }) => {
  return (
    <a
      href={href}
      onClick={(e) => {
        e.preventDefault();
        if (onClick) onClick();
      }}
      style={{
        color: COLORS.PRIMARY_BLUE,
        textDecoration: 'none',
        fontWeight: '600',
        fontSize: TYPOGRAPHY.FONT_SIZES.MD,
        ...style
      }}
      onMouseEnter={(e) => {
        e.target.style.textDecoration = 'underline';
      }}
      onMouseLeave={(e) => {
        e.target.style.textDecoration = 'none';
      }}
    >
      {children}
    </a>
  );
};

export default TimelineLink;
